import styles from "../../index.module.scss";

type Props = {
  link: string;
  children: React.ReactNode;
};

const InfoLink: React.FC<Props> = ({ link, children }) => {
  return (
    <div className={`${styles.jump_pricelist} bg-[#DDF7F6]`}>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className={styles.jump_pricelist_link}
      >
        {children}
      </a>
    </div>
  );
};

export default InfoLink;
